<script setup lang="ts">
import { useColorMode } from "@vueuse/core";
import { ref } from "vue";

const colorMode = useColorMode();

import CommonSwitch from "@/components/common/CommonSwitch.vue";

const customColor = ref(colorMode.value === "light");
const changeColorMode = (isLightThemeChecked: boolean) => {
  customColor.value = isLightThemeChecked;
  isLightThemeChecked
    ? (colorMode.value = "light")
    : (colorMode.value = "dark");
};
</script>

<template>
  <section
    class="1111 w-full theme-wrapper"
    :class="customColor"
  >
    <common-switch
      v-model:checked="customColor"
      switch-width="70px"
      class="flex justify-center items-center"
      :border="true"
      @custom-on-change="(event) => changeColorMode(event)"
    >
      <template #icon_active>
        <feather-icon
          type="sun"
          size="17"
          class="text-white"
        />
      </template>
      <template #icon_inactive>
        <feather-icon
          type="moon"
          size="17"
        />
      </template>
    </common-switch>
  </section>
</template>

<style lang="scss" scoped></style>
